module.exports = __webpack_public_path__ + "static/media/8. Gotas, Instalación, Resina cristal, 356 piezas, 2 x 2 x 2 metros, 2020 copy.ab657309.png";